import { makeStyles } from '@material-ui/core';

import { neutral } from '../../../shared/styles/colors';

export default makeStyles({
  root: {
    backgroundColor: neutral['20'],
  },
});
